import { CreateApplication as CreateApplicationPayload } from '@tran-monorepo/interfaces/applications';
import { CreateFile } from '@tran-monorepo/interfaces/files';
import { SaveDraftResult, SubmitResult } from '../../models/application-form.model';

const prefix = '[ApplicationForm]';

export class CreateApplication {
    static readonly type = `${prefix} Create Application`;
    constructor(public payload: CreateApplicationPayload) {}
}

/**
 * Same as CreateApplication but does NOT trigger navigation in the actions service.
 * Use this when creating the application implicitly (e.g. triggered by a file upload).
 */
export class CreateApplicationSilent {
    static readonly type = `${prefix} Create Application Silent`;
    constructor(public payload: CreateApplicationPayload) {}
}

export class PatchApplication {
    static readonly type = `${prefix} Patch Application`;
    constructor(
        public applicationId: string,
        public payload: CreateApplicationPayload
    ) {}
}

export class LoadApplication {
    static readonly type = `${prefix} Load Application`;
    constructor(public applicationId: string) {}
}

export class LoadDraftApplication {
    static readonly type = `${prefix} Load Draft Applications`;
}

export class LoadReferenceData {
    static readonly type = `${prefix} Load Reference Data`;
}

export class ResetApplicationFormState {
    static readonly type = `${prefix} Reset State`;
}

export class CancelApplicationLoading {
    static readonly type = `${prefix} Cancel Application Loading`;
}

export class LoadDraft {
    static readonly type = `${prefix} Load Draft`;
}

export class SaveDraftSuccess {
    static readonly type = `${prefix} Save Draft Success`;
    constructor(public result: SaveDraftResult) {}
}

export class SaveDraftFailure {
    static readonly type = `${prefix} Save Draft Failure`;
    constructor(public error: string) {}
}

export class SubmitApplication {
    static readonly type = `${prefix} Submit`;
    constructor(
        public applicationId: string | null,
        public payload: CreateApplicationPayload
    ) {}
}

export class SubmitSuccess {
    static readonly type = `${prefix} Submit Success`;
    constructor(public result: SubmitResult) {}
}

export class SubmitFailure {
    static readonly type = `${prefix} Submit Failure`;
    constructor(public error: string) {}
}

export class ClearMessage {
    static readonly type = `${prefix} Clear Message`;
}

export class ClearDraft {
    static readonly type = `${prefix} Clear Draft`;
}

export class UploadFormFile {
    static readonly type = `${prefix} Upload File`;
    constructor(public payload: { applicationId: string; fileData: CreateFile; file: File }) {}
}
